import { render, staticRenderFns } from "./userAccessForm.vue?vue&type=template&id=066c793c"
import script from "./userAccessForm.vue?vue&type=script&lang=js"
export * from "./userAccessForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports